import React, { useState, useRef, useEffect } from "react";
import "./Logos.css";
import { toast } from "react-toastify";
import CustomToast from "../../../../../Components/CustomToast/CustomToast";
import { RxCross2 } from "react-icons/rx";

// import logoLibrary from "../../../../../services/logoLibrary";
import { defaultLogoItem } from "../../../../../services/excelDataToProjectData";
import {
  dragAndDropLogo,
  deleteIcon,
  uploadIcon,
  searchIcon,
  InsetLeft,
  InsetOff,
  InsetRight,
  SideAB,
  uploadIconUpdated,
  searchIconUpdated,
  deleteUpdated,
  info,
  Delete_New,
  Upload_New,
  SearchIcon_New,
} from "../../../../../assets/icons/index";

import getRowFormettedLogoData from "../../../../utils/getRowFormettedLogoData";

import {
  NumberInput,
  Radio,
  Dropdown,
  Loader,
} from "../../../../../Components";
import LogoEdit from "./LogoEdit/LogoEdit";
import DeleteLogoEdit from "./DeleteEdit/DeleteLogoEdit";

import {
  Heading,
  Subheading,
} from "../../../../ProjectV2/Options/OptionFont/Functions";

import { uploadFileToS3 } from "../../../../../services/axios";
import { SHA256 } from "crypto-js";
import AlertModal from "./AlertModal";
import { postRequest } from "../../../../../services/axios";
import UpdateLogoEdit from "./LogoEdit/UpdateLogoEdit";
import { useDispatch, useSelector } from "react-redux";
import {
  updateProjectCreditOptionsState,
  saveOptionById,
  uploadLogoDetails,
  updateProjectCreditItems,
  updateAProjectCreditItemsState,
} from "../../../../../Redux/actions/projectActions";

import { uploadFile } from "react-s3";

const config = {
  bucketName: "elementscut",
  region: "ap-south-1",
  accessKeyId: "AKIA6LMZYPI3RLCYWVAN",
  secretAccessKey: "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",
  dirName: "logos",
};
const initialOptions = [
  { label: "None", value: 0 },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
  { label: "30%", value: 30 },
  { label: "40%", value: 40 },
  { label: "50%", value: 50 },
];

export const customToatStyle = {
  position: "top-center",
  className: "Customtoastpop",
  autoClose: true,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
  style: {
    background: "#222222",
    color: "#fff",
    outline: "1px solid  rgba(84, 96, 108, 1)",
    borderRadius: "16px",
    width: "fit-content",
    fontFamily:"manrope"
  },
};

const Logos = ({
  options,
  currentBlockIdx,
  currentBlockId,
  setReLoading,
  isCard,
}) => {
  const dispatch = useDispatch();
  const [logoEditOpen, setLogoEditOpen] = useState(false);
  const [deleteEditOpen, setDeleteEditOpen] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [filterQuery, setFilterQuery] = useState("");
  const [selectedID, setSelectedID] = useState("");
  const [logoId, setLogoId] = useState("");
  const [projectId, setProjectId] = useState("");
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [option, setOptions] = useState([...initialOptions]);
  const [file, setFile] = useState({});
  const [isUploadingModal, setIsUploadingModal] = useState(false);

  const logoLibrary = useSelector(
    (state) => state?.commonReducer?.defaultLogos
  );
  const handleChange = (key, val) => {
    dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, val));
  };

  const saveOptions = () => dispatch(saveOptionById(currentBlockId, isCard));

  const handleLogoUpload = async (file) => {
    console.log('1 logo support Alert msg');
    setFile(file);
    setIsUploadingModal(true);

    // const newFile = new File([file], file.name + Date.now(), {
    //   type: file.type,
    // });
    // uploadFile(newFile, config)
    //   .then((data) =>
    //     dispatch(
    //       uploadLogoDetails({
    //         name: fileName,
    //         url: data.location,
    //         thumbnail: data.location,
    //       })
    //     )
    //   )
  };

  const projectData = useSelector((state) => state.project?.credits);
  const projectLogos = useSelector((state) => state.project.logos);

  const logos = projectData ? projectData[currentBlockIdx].items : [];
  let defaultLogo = logoLibrary ? logoLibrary : [];
  const { rowCount, logoItems } = getRowFormettedLogoData(logos);

  let logoOptions = [...defaultLogo].filter((logo) =>
    filterQuery
      .split(" ")
      .some(
        (subQuery) =>
          logo?.name
            ?.toLowerCase()
            ?.replace(" ", "")
            ?.indexOf(subQuery.toLowerCase()) > -1
      )
  );
  console.log('logoOptions => ',logoOptions);


  const handleAddRow = () => {
    if (rowCount >= 3) return;
    const newItems = [...logos];
    for (let i = 0; i < 5; i++) {
      newItems.push({
        logo: { ...defaultLogoItem, row: rowCount, position: i },
      });
    }
    dispatch(
      updateProjectCreditItems(projectData[currentBlockIdx]["_id"], newItems)
    );
  };

  const handleDeleteRow = (rowIndex) => {
    if (rowIndex === 0) return;
    const newItems = [];

    logos.forEach((item) => {
      const logoItem = { logo: { ...item.logo } };
      if (logoItem.logo.row > rowIndex) {
        logoItem.logo.row = logoItem.logo.row - 1;
        newItems.push(logoItem);
      } else if (logoItem.logo.row < rowIndex) newItems.push(logoItem);
    });
    dispatch(
      updateProjectCreditItems(projectData[currentBlockIdx]["_id"], newItems)
    );
  };

  const logoModalProps = useRef({
    top: "50%",
    left: "50%",
  });

  const handleLogoDrop = (row, pos, logoDetails) => {
    logos.forEach((item, index) => {
      if (item.logo.row === row && item.logo.position === pos) {
        logos[index].logo = {
          ...logos[index].logo,
          url: logoDetails.url,
          thumbnail: logoDetails.thumbnail,
        };
      }
    });
    dispatch(
      updateProjectCreditItems(projectData[currentBlockIdx]["_id"], logos)
    );
  };

  const removeSelectedLogo = () => {
    const { items, _id } = projectData[currentBlockIdx];
    const { row: selectedLogoRow, position: selectedLogoPos } =
      logoModalProps.current?.selectedLogo;
    for (let i = 0; i < items.length; i++) {
      const { logo } = items[i];
      if (logo.row === selectedLogoRow && logo.position === selectedLogoPos) {
        items[i].logo = {
          ...logo,
          thumbnail: "",
          url: "",
          scale: 80,
          offset_x: 0,
          offset_y: 0,
        };
        break;
      }
    }
    dispatch(updateProjectCreditItems(_id, [...items]));
  };

  const updateLogo = ({ scale, offset_x, offset_y }) => {
    const { items, _id } = projectData[currentBlockIdx];
    const { row: selectedLogoRow, position: selectedLogoPos } =
      logoModalProps.current?.selectedLogo;
    for (let i = 0; i < items.length; i++) {
      const { logo } = items[i];
      if (logo.row === selectedLogoRow && logo.position === selectedLogoPos) {
        items[i].logo = { ...logo, scale, offset_x, offset_y };
        break;
      }
    }
    dispatch(updateProjectCreditItems(_id, [...items]));
  };

  const getValue = (value) => {
    return value ? value : "";
  };

  const handleDeleteEdit = (logo_id, project_id) => {
    setDeleteEditOpen(!deleteEditOpen);
    setLogoId(logo_id);
    setProjectId(project_id);
  };

  const openToast = (content) => {
    toast(<CustomToast title="" content={content} />, customToatStyle);
  };

  const deleteLogo = async (project_id, logo_id) => {
    try {
      const isCard = JSON.parse(localStorage.getItem("isCard")); 
      const body = { project_id, logo_id };
      const res = await postRequest(`/project/deleteLogos?isCard=${isCard}`, body);
      if (res.data.success) {
        setDeleteSuccess(true);
        openToast("Logo Deleted Successfully");
      } else {
        openToast("Something went wrong, please try again later");
      }
    } catch (error) {
      openToast("Something went wrong, please try again later");
    }
  };

  useEffect(() => {
    const idx = option.findIndex(
      (opt) => opt.value === options?.margin_vertical
    );
    if (idx !== -1) {
      setSelectedID(idx);
    }
  }, [options?.margin_vertical]);

  useEffect(() => {
    if (deleteSuccess) {
      logoLibrary.splice(
        logoLibrary.findIndex((logo) => logo._id === logoId),
        1
      );
      setDeleteSuccess(false);
    }
  }, [deleteSuccess, logoId, logoLibrary]);

  return (
    <>
    {isUploadingModal && (
        <UpdateLogoEdit
          setIsUploadingModal={setIsUploadingModal}
          file={file}
          setFile={setFile}
          setReLoading={setReLoading}
          setAlertModal={setAlertModal}
          currentBlockIdx={currentBlockIdx}
        />
      )}
    <div className="Roles-name">
      
      {alertModal && (
        <AlertModal alertModal={alertModal} setAlertModal={setAlertModal} />
      )}

      <div className="rolename-inside">
        <div className="optionSection">
          <div className="optionSectionLabel">Heading</div>
          <div className="optionSectionContent heading_padding">
            <Heading
              onChange={(val) => {
                handleChange("heading", val);
              }}
              value={getValue(options.heading)}
              onFocusOut={saveOptions}
            />
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionLabel">Sub-Heading</div>
          <div className="optionSectionContent heading_padding">
            <Subheading
              onChange={(val) => {
                handleChange("subheading", val);
              }}
              value={getValue(options.subheading ? options.subheading : "")}
              onFocusOut={saveOptions}
            />
          </div>
        </div>
        {logoItems.map((row, rowIndex) => {
          return (
            <div className="optionSection newRow ">
              <div className="addImg">
                {row?.map((logo, colIndex) => {
                  return (
                    <img
                      key={colIndex}
                      className="logoOption"
                      onClick={(evt) => {
                        if (logo.thumbnail || logo.url) {
                          logoModalProps.current = {
                            position: {
                              top: evt.pageY,
                              left: evt.pageX,
                              unit: "px",
                            },
                            selectedLogo: logo,
                          };
                          setLogoEditOpen(true);
                        }
                      }}
                      onDrop={(evt) => {
                        handleLogoDrop(
                          rowIndex,
                          colIndex,
                          JSON.parse(evt.dataTransfer.getData("text"))
                        );
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                      }}
                      src={logo.thumbnail || logo.url || dragAndDropLogo}
                      alt=""
                    />
                  );
                })}
                {rowIndex !== 0 ? (
                  <img
                    className="delete-icon"
                    src={Delete_New}
                    alt=""
                    onClick={() => handleDeleteRow(rowIndex)}
                  />
                ) : <button className="addrow-btn" onClick={handleAddRow}>+</button>}
              </div>
            </div>
          );
        })}

        



        <div className="optionSection ">
          <div className="addimgSearchBlock">

          <div className="search">
            <input type="search" className="searchInput" placeholder="Search" onChange={(evt) => setFilterQuery(evt.target.value)} />
            <img src={SearchIcon_New} alt="" />
          </div>

          <div className="uploadfile" >
            
            <label for="files">Upload a Logo</label>
            <input  className="fileInput"
              type="file"
              id="files"
              accept="image/*"
              onClick={() => alert("supported formats .jpeg .jpg .png")}
              onChange={(e) => {
                handleLogoUpload(e.target.files[0]);
                e.target.value = null;
              }}
              placeholder="Upload a Logo"
            />
            <img src={Upload_New} alt="" for="files" />
          </div>
          <div className="Helpinfo">
            <img
              className="w-5"
              src={info}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={() => window.open(`/help/66fd2903676b1a05d82dafdf`)}
            />
          </div>
        </div>
        </div>

        <div className="optionSection Logoblockborder p-1">
          <div className="logoOptions p-2 h-full flex flex-wrap justify-evenly overflow-y-scroll mr-[10px] logoCont">
            {logoOptions.map((logo, idx) =>
              logo.url || logo.thumbnail ? (
                <div className="logoImgOption relative w-[100px]  mx-2 my-auto">
                  {logo?._id && (
                    <RxCross2
                      className="crossDiv absolute text-lg z-10 top-[0.1rem] bg-gradient-to-r from-slate-500 to-purple-800 right-[0.1rem] hidden cursor-pointer text-white"
                      onClick={() =>
                        handleDeleteEdit(logo._id, logo.project_id)
                      }
                    />
                  )}
                  <img
                    className="logoOption relative "
                    key={idx}
                    src={logo.thumbnail ? logo.thumbnail : logo.url}
                    alt=""
                    draggable
                    onDragStart={(evt) => {
                      evt.dataTransfer.setData("text", JSON.stringify(logo));
                    }}
                  />
                </div>
              ) : null
            )}
          </div>
        </div>


        <div className="optionSection">
          <div className="optionSectionLabel">Block</div>
          <div className="optionSectionContent">
            <NumberInput
              postLabel="%"
              label="Width"
              value={options.column_width}
              onChange={(val) => handleChange("column_width", val)}
              min={20}
              max={100}
              onFocusOut={saveOptions}
            />
          </div>
        </div>
        
        <div className="optionSection">
          <div className="optionSectionLabel">Block Inset</div>
          <div className="optionSectionContent BLock-inset BLock-inset-nameonly">
            <Radio
              label={options.block_inset}
              options={[
                {
                  icon: InsetOff,
                  value: "default",
                  disabled:
                    options?.side_by_side === "on" &&
                    (options?.block_inset === "default" ||
                      options?.block_inset === "left" ||
                      options?.block_inset === "right"),
                },
                {
                  icon: InsetLeft,
                  value: "left",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: InsetRight,
                  value: "right",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: SideAB,
                  value: "sidebyside",
                  disabled: options?.side_by_side === "on",
                },
              ]}
              value={options.block_inset}
              onChange={(val) => {
                handleChange("block_inset", val);
                saveOptions();
              }}
              withIcon
            />
          </div>
        </div>
        {!isCard && (
          <div>
            <div className="optionSection">
          <div className="optionSectionLabel">Margin</div>
          <div className="optionSectionContent">
            <div className="label-2 label-nameonly">Vertical</div>
            <Dropdown
              // label="Vertical"
              options={option}
              selectedID={selectedID}
              value={options.margin_vertical}
              onChange={(val) => {
                handleChange("margin_vertical", val);
                saveOptions();
              }}
            />
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionContent2">
            <div className="label-1 label-nameonly">Bottom</div>
            <NumberInput
              // label="Bottom"
              value={options.extra_lines_below}
              min={0}
              max={25}
              onChange={(val) => handleChange("extra_lines_below", val)}
              onFocusOut={saveOptions}
            />
          </div>
        </div>
          </div>
        )}
         {isCard && <div></div>}
      </div>

      <LogoEdit
        logoEditOpen={logoEditOpen}
        setLogoEditOpen={setLogoEditOpen}
        {...logoModalProps.current}
        updateLogo={updateLogo}
        removeLogo={removeSelectedLogo}
      />

      {deleteEditOpen && (
        <DeleteLogoEdit
          deleteEditOpen={deleteEditOpen}
          setDeleteEditOpen={setDeleteEditOpen}
          projectId={projectId}
          logoId={logoId}
          deleteLogo={deleteLogo}
        />
      )}
    </div>
    </>
  );
};

export default Logos;
